// Must be first - sets up globals required by @axon-enterprise/i18n
import "./setupGlobals";

import React from "react";
import ReactDOM from "react-dom/client";

import "@axon-enterprise/i18n/setup";
import "@axon-enterprise/styles/dist/base.css";
import "@axon-enterprise/styles/dist/colors.css";
import "@axon-enterprise/styles/dist/theme.css";
import "./index.css";

import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 